module.exports = __webpack_public_path__ + "static/img/activity-20220904.1ec1411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20220904.png
// module id = fIkl
// module chunks = 0